import ReactDOM from "react-dom/client";
import { XAgentClientProvider } from "@shuwen/wenlv-web-activity-library";
import { App } from "@/pages/App";
import { inIframe, loadFonts } from "@/utils/common";
import { FONT_ASSETS_LIST } from "@/constants/assets";
import "./index.scss";
import { APP_CONFIG } from "./constants";
import { AppConfigContext } from "@/context";
// import { Loading } from "@/components/common/Loading";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { merge } from "@/utils/z";
import { urlParams } from "./utils";
import autofit from 'autofit.js';
import { IS_XAGENT, ENV } from "./constants/common";
// import {getData} from "./services/api";

console.log(IS_XAGENT, ENV, "IS_XAGENT,ENV");

autofit.init({
  // el: '#root',
  dw: 3120,
  dh: 1560,
  // scale: 1,
  // mode: 'fit',
  // fit: 'width',
  // fitWidth: 3120,
  // fitHeight: 1560,
})


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);



loadFonts(FONT_ASSETS_LIST);
// root.render(<Loading></Loading>);

async function renderApp(config: any = {}) {
  let data = config?.data;

  // if (!data) {
  //   // data = await getData1({ curDate: urlParams.get("curDate") });
  //   data = await getData({
  //     deviceId:deviceInfo?.deviceId,
  //     activityId:deviceInfo?.activityId||'test'
  //   });
  // }

  // console.log('data',data);

  let appConfig = merge(config?.app, APP_CONFIG);

  if (IS_XAGENT) {
    root.render(
      <AppConfigContext.Provider value={{ ...config, app: appConfig, data }}>
        <XAgentClientProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </XAgentClientProvider>
      </AppConfigContext.Provider>
    );
  } else {
    root.render(
      <AppConfigContext.Provider value={{ ...config, app: appConfig, data }}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </AppConfigContext.Provider>
    );
  }


}

renderApp();